import httpbaseURL from "../../common/axios";
class CheckListMasterService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetCheckListMaster/Create", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetCheckListMaster/List");
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetCheckListMaster/Get?id=" + doc);
  }

  getAssetByGRNId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/GetAssetByGRNId?GRNId=" + doc
    );
  }

  listAssetByItemId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/ListAssetByItemId?ItemId=" + doc
    );
  }
  //asset details fetch
  getItemDetailsByAssetId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AgreementMaster/GetItemDetailsByAssetId?AssetId=" + doc
    );
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetCheckListMaster/Update",
      doc
    );
  }
  updateStatus(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetCheckListMaster/Update",
      doc
    );
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AssetCheckListMaster/Delete?id=" + doc
    );
  }
  active(DelID, Status) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.delete(
      "AssetCheckListMaster/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
}
export default new CheckListMasterService();
